import React, { Component } from "react"
import FocusLock from "react-focus-lock"

import { MoreContext } from "./components/modals/moreContext"
import { EndSimulation } from "./components/modals/endSimulation"
import { ProtocolOverview } from "./components/modals/protocolOverview"
import { ProtocolTable } from "./components/modals/protocolTable"
import { PipetteVolume } from "./components/modals/pipetteVolume"
import { ThermocyclerControls } from "./components/modals/thermocyclerControls"
import { PopupQuestion } from "./components/modals/popupQuestion"
import { TableQuestion } from "./components/modals/tableQuestion"
import { Poster } from "./components/modals/poster"

// Animation dialogs
import { AnimationSequence } from "./components/modals/animationSequence"

// import MicroCentrifugeBalancer from "components/modal/modals/microCentrifugeBalancer/MicroCentrifugeBalancer"
// import MicroCentrifugeControls from "components/modal/modals/microCentrifugeControls/microCentrifugeControls"
// import PowerSupplyControls from "components/modal/modals/powerSupplyControls/PowerSupplyControls"
// import GelPosition from "components/modal/modals/gelPosition/GelPosition"
// import GelPipette from "components/modal/modals/gelPipette/GelPipette"

import { Undo } from "./components/modals/undo"

import close from "./img/close.svg"
import "./style.scss";

export class Modal extends Component {

  getContent = type => {
    switch (type) {
      case "PROTOCOL_READ":
        return <ProtocolOverview />;

      case "PROTOCOL_TABLE":
        return <ProtocolTable
          getGlossaryItem={this.props.getGlossaryItem}
          onOpenGlossary={this.props.onOpenGlossary} />;

      case "THERMOCYCLER_POSTER":
      case "MASTERMIX_POSTER":
        return <Poster type={type} />;

      case "PIPETTE_VOLUME":
        return <PipetteVolume id={this.props.connect} />;

      case "THERMOCYCLER_CONTROLS":
        return <ThermocyclerControls id={this.props.connect} />;

      case "DEPOSIT_SOLUTION":
      case "LOAD_GELBOX_SOLUTION":
      case "PREPARE_GELBOX":
      case "RUN_GELBOX":
      case "VISUALISE_GEL":
      case "PIPETTE_PLUNGER":
      case "PUT_ON_PPE":
      case "THERMOCYCLER_RUN":
        return <AnimationSequence
                  id={this.props.connect}
                  animation={this.props.data.animation}
                  type={type}
                  data={this.props.data}
               />;

      case "POPUP_QUESTION":
        return <PopupQuestion />;

      case "TABLE_QUESTION":
        return <TableQuestion />;

      case "MORE_CONTEXT":
        return <MoreContext />;

      case "END_SIMULATION":
        return <EndSimulation />;

      // case "MICROCENTRIFUGE_BALANCER":
      //   return <MicroCentrifugeBalancer id={this.props.connect} />;
      //
      // case "MICROCENTRIFUGE_CONTROLS":
      //   return <MicroCentrifugeControls id={this.props.connect} />;
      //
      // case "POWERSUPPLY_CONTROLS":
      //   return <PowerSupplyControls id={this.props.connect} />;
      //
      // case "GEL_POSITION":
      //   return <GelPosition id={this.props.connect}/>;
      //
      // case "GEL_PIPETTE":
      //   return (
      //     <GelPipette
      //       pipetteId={this.props.pipetteId}
      //       gelId={this.props.gelId}
      //       gelBoxId={this.props.gelBoxId}
      //     />
      //   );
      //
      case "UNDO":
        return <Undo />

      default:
        return "No modal type matched";
    }
  };

  close = () => {
    this.props.showModal({ display: false });
  };

  applyFocusLock = (innerJSX) => {
    if(this.props.noteEntryOpen || ["Predictions","Results","Reflection"].includes(this.props.sectionSelected) ){
      //No focus lock if: notesEntry is open OR predictions, results, or reflection is open
      return innerJSX
    } else {
      return (
        <FocusLock>
          {innerJSX}
        </FocusLock>
      )
    }
  }

  isPoster = (type) => {
    switch (type) {
      case "THERMOCYCLER_POSTER":
      case "MASTERMIX_POSTER":
        return true;

      default:
        return false;
    }
  }

  isAnimation = (type) => {
    switch (type) {
      case "DEPOSIT_SOLUTION":
      case "LOAD_GELBOX_SOLUTION":
      case "PREPARE_GELBOX":
      case "RUN_GELBOX":
      case "VISUALISE_GEL":
      case "PIPETTE_PLUNGER":
      case "PUT_ON_PPE":
      case "THERMOCYCLER_RUN":
        return true;

      default:
        return false;
    }
  }

  render() {
    //passes inner into above func, wraps in focus lock if needed
    let inner = (
        <div
          className={((this.isAnimation(this.props.type))?"AnimationModal ":"ProtocolModal ") + this.props.size + (!this.props.drawerOpen?" expanded":"")}
          style={{ display: this.props.display ? "flex" : "none" }}
        >
          <div
            style={{
              display: "block"
            }}
          >
            <div className="wrapper">
              {(
                !this.isAnimation(this.props.type) &&
                !this.isPoster(this.props.type)
               )?(
                <div
                  aria-label="Close Button"
                  tabIndex={0}
                  className={
                    this.props.type === "UNDO" &&
                    this.props.size === "sm"
                      ? "close-sm"
                      : "close"
                  }

                  onKeyDown={e => {
                    if (e.keyCode === 13 || e.keyCode === 32) this.close(e);
                  }}
                  onClick={this.close}
                >
                  <p>
                    Close{" "}
                    <img
                      style={{
                        display: "inline-block",
                        top: "3px",
                        position: "relative"
                      }}
                      src={close}
                      alt="Close button"
                    />
                  </p>
                </div>
              ):null}
              {this.getContent(this.props.type)}
            </div>
          </div>
        </div>
    );

    return (this.applyFocusLock(inner))
  }
}
